import { useEffect, useRef, useState } from "react";
import { connect } from 'react-redux';
import { get_categorias } from "../redux/actions/categorias";
import '../css/CategoryList.css';
import { LuPlus, LuMinus } from "react-icons/lu";

const CategoryList = ({ get_categorias, categorias, mostrarPorCategoria, mostrarPorEquipo }) => {
    useEffect(() => {
        get_categorias();
    }, [get_categorias]);

    const categoryRef = useRef(null);
    const [showSecciones, setShowSecciones] = useState(false);
    const [currentCategory, setCurrentCategory] = useState(null);
    const [selectedSeccion, setSelectedSeccion] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleClickOutside = (event) => {
        if (categoryRef.current && !categoryRef.current.contains(event.target)) {
            setShowSecciones(false);
            setCurrentCategory(null);
            setSelectedSeccion(null);
            setIsMobileMenuOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleCategoryClick = (categoria) => {
        if (categoria === "Todo") {
            setCurrentCategory(null);
            setSelectedSeccion(null);
            setShowSecciones(false);
            mostrarPorCategoria("Todo");
            setIsMobileMenuOpen(false); 
        } else {
            if (categoria.secciones && categoria.secciones.length > 0) {
                setCurrentCategory(categoria);
                setShowSecciones(true);
                setSelectedSeccion(null);
                mostrarPorCategoria(categoria.nombre);
            } else {
                setCurrentCategory(categoria);
                setShowSecciones(false);
                setSelectedSeccion(null);
                mostrarPorCategoria(categoria.nombre);
                setIsMobileMenuOpen(false);
            }
        }
    };

    const handleSeccionClick = (seccion, event) => {
        event.stopPropagation();
        setSelectedSeccion(seccion);
        mostrarPorCategoria(currentCategory.nombre, seccion.nombre);
        setIsMobileMenuOpen(false); 
    };

    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window !== 'undefined') {
            return window.matchMedia('(max-width: 1270px)').matches;
        }
        return false;
    });
    useEffect(() => {
        const handler = () => {
            setIsMobile(window.matchMedia('(max-width: 1270px)').matches);
        };
        window.addEventListener('resize', handler);
        return () => window.removeEventListener('resize', handler);
    }, []);

    return (
        <>
            {isMobile && (
                <button
                    className="categorias-toggle"
                    aria-label={isMobileMenuOpen ? 'Cerrar menú de categorías' : 'Abrir menú de categorías'}
                    onClick={() => setIsMobileMenuOpen((open) => !open)}
                >
                    {isMobileMenuOpen ? <LuMinus /> : <LuPlus />}
                </button>
            )}
            <div
                ref={categoryRef}
                className={`categorias${isMobile && isMobileMenuOpen ? ' open' : ''}`}
                style={isMobile && !isMobileMenuOpen ? { pointerEvents: 'none', visibility: 'hidden' } : {}}
            >
                <div className="categorias__table">
                    <table>
                        <thead className="categorias__thead">
                            <tr>
                                <th className="categorias__title">
                                    <span className="categorias__title-text" data-text="Categorías">Categorías</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="categorias_list" onClick={() => handleCategoryClick("Todo")}> 
                                <td>{"Todo"} {(!currentCategory && !showSecciones) ? <LuMinus /> : <LuPlus />}</td>
                            </tr>
                            {categorias && categorias.map(categoria => (
                                <tr className="categorias_list" key={categoria.id} onClick={() => handleCategoryClick(categoria)}>
                                    <td>{categoria.nombre} {currentCategory && currentCategory.id === categoria.id  ? <LuMinus /> : <LuPlus />}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {showSecciones && currentCategory && currentCategory.secciones && (
                    isMobile ? (
                        <div style={{ width: '100vw', maxWidth: '100vw', background: '#fff', borderRadius: 0, margin: 0, padding: 0 }}>
                            <div className="sub_categorias__header">
                                <h2
                                    className={`sub_categorias__title ${!selectedSeccion ? 'selected' : ''}`}
                                    onClick={() => {
                                        setSelectedSeccion(null);
                                        mostrarPorCategoria(currentCategory.nombre);
                                    }}
                                >
                                    {currentCategory.nombre}
                                </h2>
                                <button
                                    className="close-button"
                                    onClick={() => setShowSecciones(false)}
                                >
                                    &times;
                                </button>
                            </div>
                            <ul className="sub_categorias_list">
                                {currentCategory.secciones && currentCategory.secciones.map(seccion => (
                                    <li
                                        key={seccion.id}
                                        className={`sub_categoria_list_item ${selectedSeccion && selectedSeccion.id === seccion.id ? 'selected' : ''}`}
                                        onClick={(event) => handleSeccionClick(seccion, event)}
                                    >
                                        {seccion.nombre}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : (
                        <div className="sub_categorias__table">
                            <div className="sub_categorias__header">
                                <h2
                                    className={`sub_categorias__title ${!selectedSeccion ? 'selected' : ''}`}
                                    onClick={() => {
                                        setSelectedSeccion(null);
                                        mostrarPorCategoria(currentCategory.nombre);
                                    }}
                                >
                                    {currentCategory.nombre}
                                </h2>
                                <button
                                    className="close-button"
                                    onClick={() => setShowSecciones(false)}
                                >
                                    &times;
                                </button>
                            </div>
                            <ul className="sub_categorias_list">
                                {currentCategory.secciones && currentCategory.secciones.map(seccion => (
                                    <li
                                        key={seccion.id}
                                        className={`sub_categoria_list_item ${selectedSeccion && selectedSeccion.id === seccion.id ? 'selected' : ''}`}
                                        onClick={(event) => handleSeccionClick(seccion, event)}
                                    >
                                        {seccion.nombre}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )
                )}
            </div>
        </>
    );
};

const mapStateToProps = state => ({
    categorias: state.Categorias.categorias,
});

export default connect(mapStateToProps, {
    get_categorias,
})(CategoryList);